import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';


/*
* 新闻类别列表
* @param {}
* */

export const GetNewsCategoryList =()=>{
  return GET(PSY_URI.NEWS_CATEGORY_LIST);
}

